exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-ee3892f0]{cursor:pointer}.m-b-none[data-v-ee3892f0]{margin-bottom:0}", ""]);

// exports
